import React from 'react'
import PageHeader from '../components/PageHeader'
import './Contact.css'

function Contact() {
    return (
        <>
            <PageHeader title="Contact Us" />

            <div
                className="contact-form-section"
                style={{ background: 'var(--secondary-color)' }}
            >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="contact-form-img">
                                <figure className="image-anime reveal">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/contact-us-img.jpg`}
                                        alt="Contact Us"
                                    />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="section-title">
                                <h3 className="wow fadeInUp">contact us</h3>
                                <h2
                                    className="text-anime-style-2"
                                    data-cursor="-opaque"
                                >
                                    Get in Touch <span>with Us</span>
                                </h2>
                                <p
                                    className="wow fadeInUp"
                                    data-wow-delay="0.2s"
                                >
                                    Have questions or need assistance? Reach out
                                    to us directly through any of the channels
                                    below.
                                </p>
                            </div>

                            <div
                                className="contact-list wow fadeInUp"
                                data-wow-delay="0.4s"
                            >
                                <div className="contact-list-item">
                                    <div className="contact-list-icon">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/icon-location.svg`}
                                            alt=""
                                        />
                                    </div>
                                    <div className="contact-list-content">
                                        <h3>Visit Our Office</h3>
                                        <p>
                                            11 Kola Adeyeye CMD Road Magodo,
                                            Lagos, Nigeria
                                        </p>
                                    </div>
                                </div>

                                <div className="contact-list-item">
                                    <div className="contact-list-icon">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/icon-phone.svg`}
                                            alt=""
                                        />
                                    </div>
                                    <div className="contact-list-content">
                                        <h3>Call Us Anytime</h3>
                                        <p>
                                            <a href="tel:+2349030539530">
                                                +234 906 972 4769
                                            </a>
                                        </p>
                                        <p>
                                            <a href="tel:+2347058030389">
                                                +234 705 803 0389
                                            </a>
                                        </p>
                                    </div>
                                </div>

                                <a
                                    href="https://wa.me/2349069724769"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-list-item"
                                >
                                    <div className="contact-list-icon">
                                        <i className="fa-brands fa-whatsapp"></i>
                                    </div>
                                    <div className="contact-list-content">
                                        <h3>Chat on WhatsApp</h3>
                                        <p>Start a Chat</p>
                                    </div>
                                </a>

                                <div className="contact-list-item">
                                    <div className="contact-list-icon">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/icon-mail.svg`}
                                            alt=""
                                        />
                                    </div>
                                    <div className="contact-list-content">
                                        <h3>Send an Email</h3>
                                        <p>
                                            <a href="mailto:info@fidelanchor.com">
                                                info@fidelanchor.com
                                            </a>
                                        </p>
                                        <p>
                                            <a href="mailto:cooperative@fidelanchor.com">
                                                cooperative@fidelanchor.com
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="google-map">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="google-map-iframe">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.32724906844!2d3.373145274631062!3d6.606195493387732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b92544488699d%3A0x51ceafebfec269c2!2s11%20Kola%20Adeyeye%20St%2C%20Ketu%2C%20Lagos%20105102%2C%20Lagos!5e0!3m2!1sen!2sng!4v1770898826852!5m2!1sen!2sng"
                                    width="600"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Maps"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact
